/**
 * 学习乐园 · 连连看题材包：字母大小写（lianliankan/pack-daxiaoxie.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：大写连小写（「A」连「a」）。note 存一个该字母开头的高频
 * 单词与中文（「Aa apple 苹果」）——配上的那一瞬顺口读一遍，26 个字母
 * 名与字母词一起过（消除与配错反馈双向展示）。
 * 盘面 6×8=48 格（24 对/局），26 对备 2 对变化；单字符牌面走最大字号档。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.daxiaoxie = {
    id: 'daxiaoxie',
    name: '字母大小写',
    hint: 'A 连 a，配对带字母词',
    kind: 'rel',
    cols: 6,
    rows: 8,
    pairs: [
      { l: 'A', r: 'a', note: 'Aa apple 苹果' },
      { l: 'B', r: 'b', note: 'Bb book 书' },
      { l: 'C', r: 'c', note: 'Cc cat 猫' },
      { l: 'D', r: 'd', note: 'Dd dog 狗' },
      { l: 'E', r: 'e', note: 'Ee egg 鸡蛋' },
      { l: 'F', r: 'f', note: 'Ff fish 鱼' },
      { l: 'G', r: 'g', note: 'Gg girl 女孩' },
      { l: 'H', r: 'h', note: 'Hh hand 手' },
      { l: 'I', r: 'i', note: 'Ii ice 冰' },
      { l: 'J', r: 'j', note: 'Jj jump 跳' },
      { l: 'K', r: 'k', note: 'Kk kite 风筝' },
      { l: 'L', r: 'l', note: 'Ll lion 狮子' },
      { l: 'M', r: 'm', note: 'Mm moon 月亮' },
      { l: 'N', r: 'n', note: 'Nn nose 鼻子' },
      { l: 'O', r: 'o', note: 'Oo orange 橙子' },
      { l: 'P', r: 'p', note: 'Pp panda 熊猫' },
      { l: 'Q', r: 'q', note: 'Qq queen 女王' },
      { l: 'R', r: 'r', note: 'Rr rain 雨' },
      { l: 'S', r: 's', note: 'Ss sun 太阳' },
      { l: 'T', r: 't', note: 'Tt tree 树' },
      { l: 'U', r: 'u', note: 'Uu umbrella 雨伞' },
      { l: 'V', r: 'v', note: 'Vv violin 小提琴' },
      { l: 'W', r: 'w', note: 'Ww water 水' },
      { l: 'X', r: 'x', note: 'Xx X-ray X光' },
      { l: 'Y', r: 'y', note: 'Yy yellow 黄色' },
      { l: 'Z', r: 'z', note: 'Zz zoo 动物园' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
